export default "__VITE_ASSET___VmPA2fb__"